module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"Sign In":"Войти","Mobile Sign In":"Войти в ХаниМани в Кармане","Stay signed in":"Запомнить меня","Password":"Пароль","forgot_password":"Я забыл пароль :("},"en":{"forgot_password":"Forgot your password?"}}')
  delete Component.options._Ctor
}
